import {Observable, BehaviorSubject} from 'rxjs';
import { Storage } from '@ionic/storage';
import { Resources } from '../models/resources';
import { Store } from './store';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';

@Injectable()
export class ResourceStore extends Store<Resources> {

    constructor(storage: Storage) {
        super(Resources.defaults(), 'resources.ta.v2', storage);
    }

    setResources(resources: Resources): Promise<void> {
        return this.setState(resources);
    }

    getResources(): Resources {
        return this.state;
    }

    clearResources(): void {
        this.setState(Resources.defaults());
    }

    get state (): Resources {
        return plainToClass(Resources, super.state || Resources.defaults()) as Resources
    }

}